import AddressFormatterFunctional from 'src/components/Layouts/AddressFormatterFunctional';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: `${i18n.t('common_words.map')} ${i18n.t(
        'sweet_alert.jobs.of_the_farm'
      )}`,
      show: false,
      showMap: true,
    },
    {
      prop: 'geo',
      label: i18n.t('common_words.geo_position'),
      show: false,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
      align: 'center',
      minWidth: 100,
    },
    {
      prop: 'area',
      label: i18n.t('common_words.farm_size_ha'),
      show: false,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'cost_center',
      label: i18n.t('common_words.cost_center'),
      show: false,
    },
    {
      prop: 'email_notification',
      label: i18n.t('common_words.notification_email'),
      show: false,
    },
    {
      prop: 'management_roles',
      label: i18n.t('common_words.administrative_roles'),
      show: false,
      mgmtRoles: true,
    },
    {
      prop: 'blocks_number',
      label: i18n.t('common_words.blocks_number_2'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'crop.name',
      label: i18n.t('common_words.crop'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'cropType.name',
      label: i18n.t('common_words.type_of_crop'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'state',
      label: i18n.t('common_words.location'),
      minWidth: 250,
      sortable: true,
      formatter: AddressFormatterFunctional,
    },
    {
      prop: 'zone.name',
      label: i18n.t('common_words.zone'),
      show: false,
    },
    {
      prop: 'state',
      label: `${i18n.t('common_words.blocks')} / ${i18n.t(
        'common_words.allotments'
      )}`,
      show: false,
      lots: true,
    },
    {
      prop: 'packing_houses',
      label: i18n.t('common_words.packing_houses'),
      packingHouses: true,
      show: false,
    },
  ];

  return { tableColumns };
};

export default configTable;
